/* 🤖 this file was generated by svg-to-ts */
export const DfIconPersonDouble16: {
  name: 'person-double-16';
  data: string;
} = {
  name: 'person-double-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M0 14v-2.1c1.5-.2 3-.2 3-1.9 0-2.004-1.5-2.996-1.5-5S2.129 0 5 0c2.342 0 3.192 1.995 3.426 3.817C8.773 2.357 9.629 1 11.5 1c2.692 0 3.281 2.811 3.281 4.688s-1.406 2.816-1.406 4.687c0 1.522 1.284 1.59 2.625 1.757V14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.274-7.679C7.854 7.553 7 8.494 7 10c0 1.252.814 1.581 1.843 1.748.473-.23.782-.627.782-1.373 0-1.655-1.091-2.574-1.351-4.054z"/></svg>`
};
